module.exports = __webpack_public_path__ + "static/media/toss_up.1f7b3b14.ogg";